var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qualityTracking"},[_vm._v("\n    质量追溯\n")])}
var staticRenderFns = []

export { render, staticRenderFns }